import Components from "views/Components/Components.jsx";
import AllPosts from "../views/Components/AllPosts/AllPosts.jsx";
import AllMarket from "../views/Components/AllMarket/AllMarket.jsx";
import LandingPage from "views/LandingPage/LandingPage.jsx";
import ProfilePage from "views/ProfilePage/ProfilePage.jsx";
// import LoginPage from "views/LoginPage/LoginPage.jsx";
import AboutUS from '../views/Components/Contents/AboutUS';
import Rouls from '../views/Components/Contents/Rouls';
import ContactUs from '../views/Components/Contents/ContactUs';


var indexRoutes = [
  { path: "/", name: "Components", component: Components },
  { path: "/posts", name: "Posts", component: AllPosts },
  { path: "/market", name: "Market", component: AllMarket },
  { path: "/AbouatUs", name: "AbouatUs", component: AboutUS },
  { path: "/Rouls", name: "Rouls", component: Rouls },
  { path: "/ContactUs", name: "ContactUs", component: ContactUs },
  { path: "/landing-page", name: "LandingPage", component: LandingPage },
  { path: "/profile-page", name: "ProfilePage", component: ProfilePage },
  // { path: "/login-page", name: "LoginPage", component: LoginPage },
];

export default indexRoutes;
